/*
 * @Author: your name
 * @Date: 2022-03-02 15:34:12
 * @LastEditTime: 2025-03-20 10:32:12
 * @LastEditors: kevinqq 350910378@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\components\BsyAlertMenu\Staticize.jsx
 */
import React, { Component } from "react";
import "./index.css";

class AlertList extends Component {
  Close = () => {
    if (this.props && this.props.onClose) {
      if (this.props.onClose() !== false) {
        this.props.onRemoveRoot();
        // document.getElementsByClassName("BsyAlertMenu").length > 0 && document.getElementsByClassName("BsyAlertMenu")[0].remove()
      }
    } else {
      this.props.onRemoveRoot();
      // document.getElementsByClassName("BsyAlertMenu").length > 0 && document.getElementsByClassName("BsyAlertMenu")[0].remove()
    }
  };

  render() {
    const { item, customCls } = this.props;
    return (
      <div
        className={
          "content " + window.mode + " " + (customCls ? customCls : "")
        }
      >
        {item.map((val, key) => {

          if(val.line && !val.text) {
            return <div className="line" />
          }

          return (
            <>
              <div
                key={`key-${key}`}
                style={{
                  height: val.itemHeight ? val.itemHeight : "",
                  color: val.color ? val.color : "",
                }}
                onClick={(e) => {
                  this.Close();
                  val.click(this, e);
                }}
                className={`item ${val.colorType ? val.colorType : ""} ${
                  val.customCls ? val.customCls : ""
                } ${val.selected ? "selected" : ""}`}
                onMouseEnter={(event) => {
                  val.onMouseEnter && val.onMouseEnter(event);
                }}
                onMouseLeave={(event) => {
                  val.onMouseLeave && val.onMouseLeave(event);
                }}
                title={val.text ? val.text : ""}
              >
                <div className="item-content" key={`key-t-${key}`}>
                  {val.icon ? (
                    <i
                      className={`before-icon ${val.icon ? val.icon : ""}`}
                      style={{ color: val.iconColor ? val.iconColor : "" }}
                    />
                  ) : (
                    ""
                  )}
                  {val.text ? (
                    <span
                      title={val.text}
                      style={{ color: val.textColor ? val.textColor : "" }}
                    >
                      {val.text}
                    </span>
                  ) : (
                    ""
                  )}
                  {val.afterText ? (
                    <span style={{ color: val.afterTextColor, flex: "none" }}>
                      （{val.afterText}）
                    </span>
                  ) : (
                    ""
                  )}
                </div>

                {val.extIcon ? (
                  <i
                    className={`ext-icon ${val.extIcon ? val.extIcon : ""}`}
                    style={{
                      color: val.extIconColor ? val.extIconColor : "",
                      //   marginLeft: 12,
                    }}
                  />
                ) : (
                  ""
                )}
              </div>
              {val.line && <div className="line" />}
            </>
          );
        })}
      </div>
    );
  }
}

export default AlertList;
